export const MAX_ITEM_PER_PAGE: number = 20;
